import { render } from "./Warnings.vue?vue&type=template&id=2b1c3b44&scoped=true"
import script from "./Warnings.vue?vue&type=script&lang=js"
export * from "./Warnings.vue?vue&type=script&lang=js"

import "./Warnings.vue?vue&type=style&index=0&id=2b1c3b44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b1c3b44"]])

export default __exports__